export default __webpack_public_path__ + "overview-960-74296402bd3f7c16abcddcfc495ad876.webp";